/**
 * Joins multiple strings into a single comma-separated string.
 */
export const joinWithComma = (...values: string[]): string => {
    return values.join(', ');
};
